<app-page-not-found *ngIf="showCheckoutRootNotFound"></app-page-not-found>
<router-outlet *ngIf="!showCheckoutRootNotFound"></router-outlet>
<ngx-spinner></ngx-spinner>
